module.exports = __webpack_public_path__ + "img/1.971fe5ae.jpg";